import { render, staticRenderFns } from "./SchaDonorListComp.vue?vue&type=template&id=216ce774&scoped=true"
import script from "./SchaDonorListComp.vue?vue&type=script&lang=js"
export * from "./SchaDonorListComp.vue?vue&type=script&lang=js"
import style1 from "./SchaDonorListComp.vue?vue&type=style&index=1&id=216ce774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216ce774",
  null
  
)

export default component.exports